import {
  ar, bg, de, enUS, enGB, es, fr, el, hr, it,
  pt, ptBR, ro, ru, sr, tr, zhCN, zhTW,
} from "date-fns/locale"
import { Locale } from "date-fns"
import { t } from "@lingui/macro"

export const localesMap: Record<string, Locale> = {
  ar,
  bg,
  de,
  "en": enUS,
  "en-us": enUS,
  "en-gb": enGB,
  es,
  fr,
  el,
  hr,
  it,
  pt,
  "pt-br": ptBR,
  ro,
  ru,
  sr,
  tr,
  "zh": zhCN,
  "zh-cn": zhCN,
  "zh-tw": zhTW,
} as const

export const mapLanguageToDateFnsLocale = (languageString: string): Locale => {
  const normalizedToLower = languageString.toLowerCase()

  if (localesMap[normalizedToLower]) return localesMap[normalizedToLower]

  const baseLanguage = languageString.slice(0,2)
  if(localesMap[baseLanguage]) return localesMap[baseLanguage]

  return enUS
}

export type LanguageOption = {
  id: string
  label: string
}

export const getLanguageOptions = (): LanguageOption[] => [
  {
    id: "en-EN",
    label: t({ message: "English", id: "language_english" }),
  },
  { id: "de-DE", label: t({ message: "German", id: "language_german" }) },
  { id: "es-ES", label: t({ message: "Spanish", id: "language_spanish" }) },
  { id: "fr-FR", label: t({ message: "French", id: "language_french" }) },
  { id: "it-IT", label: t({ message: "Italian", id: "language_italian" }) },
  {
    id: "pt-PT",
    label: t({ message: "Portuguese", id: "language_portuguese" }),
  },
  {
    id: "hr-HR",
    label: t({ message: "Croatian", id: "language_croatian" }),
  },
  { id: "ru-RU", label: t({ message: "Russian", id: "language_russian" }) },
  {
    id: "ro-RO",
    label: t({ message: "Romanian", id: "language_romanian" }),
  },
  {
    id: "bg-BG",
    label: t({ message: "Bulgarian", id: "language_bulgarian" }),
  },
  { id: "gr-GR", label: t({ message: "Greek", id: "language_greek" }) },
  { id: "sr-SR", label: t({ message: "Serbian", id: "language_serbian" }) },
  { id: "tr-TR", label: t({ message: "Turkish", id: "language_turkish" }) },
  { id: "ar-AR", label: t({ message: "Arabic", id: "language_arabic" }) },
  { id: "zh-ZH", label: t({ message: "Chinese", id: "language_chinese" }) },
]
